import "./App.css";
import Header from "./components/header";
import { useState } from "react";
import Form from "./components/BlankForm";
import Thankyou from "./components/Thankyou";

function App() {
  const [cardNumber, setCardNumber] = useState<string | null>(null);
  const [cvc, setCvc] = useState<null | string>(null);
  const [cardHolder, setCardHolder] = useState<null | string>(null);
  const [month, setMonth] = useState<null | string>(null);
  const [year, setYear] = useState<null | string>(null);
  const [completed, setCompleted] = useState<boolean>(false);
  const [blank, setBlank] = useState(false);

  function checkForm() {
    if (cardHolder && cardNumber && month && year && cvc) {
      setCompleted(!completed);
    } else {
      if (!month || !year || !cvc) setBlank(true);
    }
  }

  function reset() {
    window.location.reload();
    setCompleted(false);
  }

  return (
    <div className="App">
      <main>
        <Header
          cvc={cvc}
          cardNumber={cardNumber}
          cardholder={cardHolder}
          month={month}
          year={year}
        />

        <div className="container">
          {!completed ? (
            <Form
              setCardHolder={setCardHolder}
              setCardNumber={setCardNumber}
              setCvc={setCvc}
              setMonth={setMonth}
              setYear={setYear}
              setCompleted={setCompleted}
              setBlank={setBlank}
            />
          ) : (
            ""
          )}
          {blank ? <p> Cant' be blank</p> : ""}

          {!completed ? <button onClick={checkForm}>Confirm</button> : ""}
          {completed ? <Thankyou /> : ""}
          {completed ? <button onClick={reset}>Continue</button> : ""}
        </div>
      </main>
    </div>
  );
}

export default App;
